import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// VITE_API_URL NO se valida acá — es var muerta en hexa-login (ningún módulo la lee, ver
// hexa/README y la auditoría de compatibilidad con Coolify); mantenerla en REQUIRED_VARS
// invitaba a completarla pensando que tenía efecto. VITE_AUTH_URL sí se usa (hexa-login/src/
// api/auth.ts) y ahora se hornea VACÍA a propósito (nginx la resuelve por proxy same-origin,
// ver hexa-login/nginx.conf y el build-arg en docker-compose.yml) — sigue siendo obligatoria
// pasarla como build-arg (aunque sea `""`), porque si el build-arg falta del todo Vite la deja
// `undefined` y `${AUTH_URL}/auth/login` en auth.ts compone la URL literal "undefined/auth/
// login". Por eso el chequeo es contra `undefined`, no falsy: una string vacía es un valor
// válido e intencional, no "falta".
const REQUIRED_VARS = ['VITE_AUTH_URL'] as const;

function validateConfig() {
  const missing = REQUIRED_VARS.filter((k) => import.meta.env[k] === undefined);
  if (missing.length > 0) {
    console.error('[hexa-login] Missing required environment variables:', missing);
  }
}

validateConfig();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
